import { useEffect, useState } from 'react';
import { eventTimes } from './constants';
import type EventManager from './EventManager';
import { EventName } from './types';

const useEventTrigger = (eventManager: EventManager, eventName: EventName) => {
  const [updateFlag, setUpdateFlag] = useState(eventTimes[eventName]);
  const [updateOffset, setUpdateOffset] = useState(0);

  useEffect(() => {
    eventManager.on(eventName, whenToUpdate => {
      const now = Date.now();
      const offset = whenToUpdate > now ? whenToUpdate - now : 1;

      setUpdateOffset(offset);
    });
  }, [eventManager, eventName]);

  useEffect(() => {
    if (!updateOffset) return () => {};

    const t = setTimeout(() => {
      setUpdateFlag(Date.now());
      setUpdateOffset(0);
    }, updateOffset);

    return () => clearTimeout(t);
  }, [updateOffset]);

  return updateFlag;
};

export default useEventTrigger;
